import { render, staticRenderFns } from "./ProfileEditModal.vue?vue&type=template&id=21587b96&"
import script from "./ProfileEditModal.vue?vue&type=script&lang=js&"
export * from "./ProfileEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProfileEditModal.vue"
export default component.exports